import React, { useEffect, useState, useCallback } from 'react'
import api from './api'
import s3 from './s3'

import { useParams, useNavigate } from 'react-router-dom'

import { InboxOutlined } from '@ant-design/icons'

import { Drawer, message, Select, Typography, Input, InputNumber, Button, Upload, Popconfirm, Result } from 'antd'

import { ProCard } from '@ant-design/pro-components'


import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-react'
// import { IDomEditor, IEditorConfig, IToolbarConfig } from '@wangeditor/editor'


import TurndownService from 'turndown'

const { Text, Title, Link } = Typography
const { TextArea } = Input
const { Dragger } = Upload


const markdown_ = `![](图片链接)

#### 欢迎使用 markdown 编辑器, 你可能需要学习一些 markdown 语法进行缩写文章~

### 插件介绍:
内容....

- 内容1
- 内容2

#### 安装指导:
1.  将脚本文件放入 **resources** 里面
2.  在 **server.cfg** 添加 **esnure 插件启动代码**
3.  重启服务器`


function isImage(file) {
    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/webp']
    return file && acceptedImageTypes.includes(file)
}

//  编辑器布局
function Edit(props) {
    const id = useParams()
    const navigate = useNavigate()
    const [data, setData] = useState({ category: 'server', type: 'free', exhibit: 'web', core: ['independent'], price: 0.01, resource: [], cores: [], script_rely: [], url: '', versions: [{ name: '默认版本', url: '' }] })
    const [dataKey, setDataKey] = useState(null)
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(true)
    const [update, setUpdate] = useState(null)
    const [height, setHeight] = useState(1400)

    // editor 实例
    const [editor, setEditor] = useState(null)                   // JS 语法

    // 编辑器内容
    const [html, setHtml] = useState('<p>hello</p>')

    // 工具栏配置
    const toolbarConfig = {
        excludeKeys: [
            'insertImage',    // 隐藏整个图片菜单（包括上传和网络图片）
            'insertVideo',     // 隐藏整个视频菜单
            'uploadVideo',     // 隐藏整个视频菜单
            'group-video',     // 隐藏整个视频菜单
        ],
    }                        // JS 语法

    // 编辑器配置
    const editorConfig = {                         // JS 语法
        placeholder: '请输入内容...',
        MENU_CONF: {
            uploadImage: {
                // 自定义上传
                // async customUpload(file: File, insertFn: InsertFnType) {
                // TS 语法
                async customUpload(file, insertFn) {                   // JS 语法
                    // file 即选中的文件
                    // 自己实现上传，并得到图片 url alt href
                    // 最后插入图片



                    if (!isImage(file.type)) {
                        message.error('请上传图片类型的文件,只支持gif、jpeg、png、webp等多种的图片格式')
                        return
                    }
                    if (file.size > 12457280) {
                        message.error('文件大小超过10MB,无法上传')
                        return
                    }

                    s3.upload({
                        type: 'imgs',
                        file: file,
                        name: file.name,
                        size: file.size,
                        rainyun: true,
                    }, (msg) => {
                        insertFn(msg.url)
                        message.success('图片已上传成功');
                    })
                },
            }
        }
    }

    // 及时销毁 editor ，重要！
    useEffect(() => {
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)
        }
    }, [editor]);


    useEffect(() => {
        if (id.id) {
            const nid = id.id
            api.get('/api/v2/article/', {
                params: {
                    nid: nid
                }
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        const Data = res.data.data.data.Data
                        const turndownService = new TurndownService()
                        var markdown = turndownService.turndown(Data.html)
                        if (Data.markdown) {
                            markdown = Data.markdown
                        }
                        getHosting({ ...Data, markdown: markdown })
                        setHtml(Data.html)
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器 error: ' + error)
                })
        } else {
            let aticleData = localStorage.getItem('aticleData')
            if (aticleData) {
                getHosting(JSON.parse(aticleData))
                setHtml(JSON.parse(aticleData).html)
            } else {
                getHosting({})
            }
        }
    }, [])


    useEffect(() => {
        if (!update) {
            return
        }
        setTimeout(() => {
            if (id.id) {
                return
            }
            localStorage.setItem("aticleData", JSON.stringify({ ...data, html: html }))
        }, 100)
        setTimeout(() => {
            let edit_content = document.getElementsByClassName('edit_content')[0]
            setHeight(edit_content ? edit_content.offsetHeight : 1400)
        }, 500);
    }, [update])

    function getHosting(aticleData) {
        setTimeout(() => {
            api.get('/api/v2/user/get?name=resource')
                .then((res) => {
                    if (res.data.code === 200) {
                        let Data = res.data.data.data
                        setData({
                            ...data,
                            ...aticleData,
                            ...Data
                        })
                        setLoading(false)
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器 error: ' + error)
                })
        }, 200)

        setTimeout(() => {
            let edit_content = document.getElementsByClassName('edit_content')[0]
            setHeight(edit_content ? edit_content.offsetHeight : 1300)
        }, 500)
    }

    //  文件上传
    const uploadProps = {
        name: 'file',
        maxCount: 1,
        customRequest(info) {
            if (info.file.size > 52457280) {
                message.error('文件大小超过50MB,无法上传')
                info.onError()
                return
            }
            s3.upload({
                type: 'file',
                file: info.file,
                name: info.file.name,
                size: info.file.size,
                rainyun: true,
            }, (msg) => {
                let versions = [...data.versions]
                versions[dataKey] = {
                    ...versions[dataKey],
                    url: msg.url,
                }

                setData({
                    ...data,
                    versions: versions
                })
                setUpdate(Date.now())
                setOpen(false)
                info.onSuccess()
                message.success('上传成功')
            })
        },
    }

    //  内容修改
    const onChange = useCallback((e) => {
        // let html = null
        // if (e.target.name === 'markdown') {
        //     html = window.markdown.toHTML(e.target.value)
        // }
        setUpdate(Date.now())
        // if (html) {
        //     setData({
        //         ...data,
        //         [e.target.name]: e.target.value,
        //         html: html
        //     })
        //     return
        // }
        setData({
            ...data,
            [e.target.name]: e.target.value,
        })
    }, [data])


    // editorConfig.onChange = (editor: IDomEditor) => {
    // TS 语法
    editorConfig.onChange = (editor) => {            // JS 语法
        // editor changed
        // console.log('content', editor.getHtml())
        setHtml(editor.getHtml())
        setUpdate(Date.now())
    }

    //  价格
    function onPriceChange(value) {
        setUpdate(Date.now())
        setData({
            ...data,
            price: value
        })
    }

    //  版块切换
    function handleChange(value) {
        setUpdate(Date.now())
        setData({
            ...data,
            category: value
        })
    }

    //  类型切换
    function handleTypeChange(value) {
        setUpdate(Date.now())
        setData({
            ...data,
            type: value
        })
    }

    //  展示位置
    function handleExhibitChange(value) {
        setUpdate(Date.now())
        setData({
            ...data,
            exhibit: value
        })
    }

    //  选择托管资源
    function handleValueChange(value) {
        setUpdate(Date.now())
        setData({
            ...data,
            value: value
        })
    }

    //  文件上传窗口
    const showDrawer = () => {
        setOpen(true)
    }
    const onClose = () => {
        setOpen(false)
    }

    //  重置内容
    const confirm = (e) => {
        message.success('已经重置内容了!')
        setUpdate(Date.now())
        // let html = window.markdown.toHTML(markdown_)
        setHtml('')
        setData({ category: 'server', type: 'free', exhibit: 'web', resource: [], core: ['independent'], cores: [], script_rely: [], url: '', versions: [{ name: '默认版本', url: '' }] })
    }


    //  依赖项
    const handleRelyChange = (value) => {
        setData({
            ...data,
            rely: value
        })

        setUpdate(Date.now())
    }

    //  适配版本
    const handleCoreChange = (value) => {
        setData({
            ...data,
            core: value
        })

        setUpdate(Date.now())
    }

    //  修改版本
    function onVersionChange(key, e) {
        let versions = [...data.versions]

        versions[key] = {
            ...versions[key],
            [e.target.name]: e.target.value,
        }

        setData({
            ...data,
            versions: versions
        })

        setUpdate(Date.now())
    }

    //  删除版本
    function deleteVersion(key) {
        let versions = [...data.versions]

        if (versions.length === 1) {
            return message.error('无法删除最后一个')
        }

        versions.splice(key, 1)

        setData({
            ...data,
            versions: versions
        })

        setUpdate(Date.now())
    }

    //  新增版本
    function onClick() {
        let versions = [...data.versions]
        versions.push({ name: '未命名', url: '' })

        setData({
            ...data,
            versions: versions
        })

        setUpdate(Date.now())
    }

    //  发布
    function Send() {
        let Data = {}
        if (!data.title) {
            message.warning('请填写标题再发布文章')
            return
        }
        if (!data.html) {
            message.warning('内容似乎没更改,请更改内容再发布')
            return
        }

        let result = editor.getElemsByType('image')
        if (result) {
            result = result[0].src
        }

        Data.title = data.title
        Data.label = data.label
        Data.category = data.category
        Data.type = data.type
        Data.exhibit = data.exhibit
        Data.name = data.name
        Data.describe = data.describe
        Data.price = data.price
        Data.versions = data.versions
        Data.markdown = data.markdown
        Data.html = html
        Data.value = data.value
        Data.rely = data.rely ? data.rely : []
        Data.core = data.core
        Data.img = result
        Data.article_type = true

        api.post('/api/v2/article/', {
            data: JSON.stringify(Data),
        })
            .then((res) => {
                if (res.data.code === 200) {
                    navigate('/')
                    message.success(res.data.data.text)
                    localStorage.removeItem('aticleData')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器 error: ' + error)
            })
    }

    //  更新
    function Save() {
        let Data = {}
        if (!data.title) {
            message.warning('请填写标题再发布文章')
            return
        }
        if (!data.html) {
            message.warning('内容似乎没更改,请更改内容再发布')
            return
        }

        let result = editor.getElemsByType('image')
        if (result) {
            result = result[0].src
        }

        Data.nid = id.id
        Data.title = data.title
        Data.label = data.label
        Data.category = data.category
        Data.type = data.type
        Data.exhibit = data.exhibit
        Data.name = data.name
        Data.describe = data.describe
        Data.price = data.price
        Data.versions = data.versions
        Data.markdown = data.markdown
        Data.html = html
        Data.value = data.value
        Data.rely = data.rely ? data.rely : []
        Data.core = data.core
        Data.img = result
        Data.article_type = false

        api.post('/api/v2/article/', {
            data: JSON.stringify(Data),
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setTimeout(() => {
                        navigate('/t/' + id.id)
                        message.success(res.data.data.text)
                        localStorage.removeItem('aticleData')
                    }, 500);
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器 error: ' + error)
            })
    }

    // if (!props.verifyAy('admin')) {
    //     return (
    //         <Result
    //             status="403"
    //             title="403"
    //             subTitle="暂时还没开放, 正在维护调整..."
    //         />
    //     )
    // }

    if (!props.state.token) {
        return (
            <Result
                status="403"
                title="403"
                subTitle="请登录再访问页面"
            />
        )
    }

    if (!props.state.user.phone_number) {
        message.error('根据用户协议, 你需要绑定手机号才能使用此功能!')
        const link = document.createElement('a')
        link.href = '/bindingphone'
        link.click()
        return
    }

    let options = [
        {
            label: '官方区',
            options: [
                {
                    label: '公告',
                    value: 'notify',
                },
                {
                    label: '付费资源',
                    value: 'vip',
                },
            ],
        },
        {
            label: '资源区',
            options: [
                {
                    label: '服务器资源',
                    value: 'server',
                },
                {
                    label: '外网开源',
                    value: 'Extranet',
                },
                {
                    label: '模组 | MOD',
                    value: 'mods',
                },
                {
                    label: '教程',
                    value: 'tutorial',
                },
                {
                    label: '服务端',
                    value: 'Server',
                },
            ],
        },
    ]

    let options2 = [
        {
            label: '免费内容',
            value: 'free',
        },
        {
            label: '付费内容',
            value: 'vip',
            disabled: data.category !== 'vip'
        },
    ]

    if (!props.verifyAy('admin')) {
        options = [
            {
                label: '资源区',
                options: [
                    {
                        label: '服务器资源',
                        value: 'server',
                    },
                    {
                        label: '外网开源',
                        value: 'Extranet',
                    },
                    {
                        label: '模组 | MOD',
                        value: 'mods',
                    },
                    {
                        label: '教程',
                        value: 'tutorial',
                    },
                    {
                        label: '服务端',
                        value: 'Server',
                    },
                ],
            },
        ]

        options2 = [
            {
                label: '免费内容',
                value: 'free',
            },
        ]
    }

    return (
        <div style={{ height: height }}>
            <div style={{ width: '65%' }} className='edit_content'>
                <Title level={3}>文章编辑器</Title>
                <ProCard title={<Text>信息配置</Text>} bordered headerBordered style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', marginBottom: 20 }} loading={loading}>
                    <Input placeholder="标题" addonBefore='标题' style={{ width: 400 }} name='title' value={data.title} onChange={onChange} />
                    <Input placeholder="标签 (使用 , 来分隔)" addonBefore='标签' style={{ width: 300, marginLeft: 20 }} name='label' value={data.label} onChange={onChange} />
                    <div style={{ marginTop: 20, marginBottom: 20 }}>
                        <Select
                            style={{
                                width: 200,
                            }}
                            onChange={handleChange}
                            value={data.category}
                            options={options}
                        />

                        <Select
                            style={{
                                width: 150,
                                marginLeft: 20
                            }}
                            value={data.exhibit}
                            onChange={handleExhibitChange}
                            options={[
                                // {
                                //     label: '全部',
                                //     value: 'all',
                                // },
                                // {
                                //     label: 'NZadmin',
                                //     value: 'nzadmin',
                                // },
                                {
                                    label: '网站',
                                    value: 'web',
                                }
                            ]}
                        />

                        <Select
                            style={{
                                width: 150,
                                marginLeft: 20,
                                marginRight: 20
                            }}
                            value={data.type}
                            onChange={handleTypeChange}
                            options={options2}
                        />

                        {data.type === 'vip' ? <>
                            <InputNumber addonBefore='价格' min={0.01} defaultValue={0.01} hidden={false} value={data.price} onChange={onPriceChange} />

                            {/* <Select
                                style={{
                                    width: 400,
                                    marginLeft: 20,
                                    marginRight: 20
                                }}
                                onChange={handleValueChange}
                                options={data.resource}
                                value={data.value}
                            /> */}
                        </> : null}
                    </div>
                </ProCard>


                {(data.exhibit === 'all' || data.exhibit === 'nzadmin') ?
                    <ProCard title={<Text>NZadmin配置</Text>} bordered headerBordered style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', marginBottom: 20 }} loading={loading}>
                        <Input placeholder="资源代码" addonBefore='资源代码' style={{ width: 400 }} name='name' value={data.name} onChange={onChange} />
                        <Input placeholder="介绍" addonBefore='介绍' style={{ width: 400, marginLeft: 20 }} name='describe' value={data.describe} onChange={onChange} />
                    </ProCard>
                    : null}

                <ProCard title={<Text>文件版本号</Text>} bordered headerBordered style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', marginBottom: 20 }} loading={loading}>
                    <div style={{ marginBottom: 20 }}>
                        <Button type="primary" onClick={onClick}>新增版本</Button>
                    </div>

                    {data.versions.map((i, key) => {
                        return (
                            <div key={key}>
                                <ProCard title={<Text>{i.name}</Text>} bordered headerBordered style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', marginBottom: 20 }}>
                                    <Input placeholder="名称" style={{ width: 200, marginRight: 20 }} name='name' value={i.name} onChange={(e) => { onVersionChange(key, e) }} />
                                    <Input placeholder="文件链接" style={{ width: 400, marginRight: 20 }} name='url' value={i.url} onChange={(e) => { onVersionChange(key, e) }} />
                                    <Input placeholder="文件提取码" addonBefore='提取码' style={{ width: 200, marginRight: 20, display: i.url.indexOf('n2yun.com.cn') !== -1 ? 'none' : null }} name='code' value={i.code} onChange={(e) => { onVersionChange(key, e) }} />
                                    <Button onClick={() => {
                                        setDataKey(key)
                                        showDrawer()
                                    }}>上传文件</Button>
                                    <Button type="primary" style={{ marginLeft: 20 }} danger onClick={() => { deleteVersion(key) }} disabled={data.versions.length <= 1 ? true : false}>删除</Button>
                                </ProCard>
                            </div>
                        )
                    })}
                </ProCard>

                <ProCard title={<Text>依赖项</Text>} bordered headerBordered style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', marginBottom: 20 }} loading={loading}>
                    <div style={{ marginBottom: 20 }}>
                        <Button type="primary" onClick={() => { navigate('/rely_edit') }}>新增依赖项</Button>
                    </div>
                    <Select
                        mode="multiple"
                        style={{
                            width: '100%',
                        }}
                        placeholder="选择当前插件所需要的依赖项"
                        onChange={handleRelyChange}
                        options={data.script_rely}
                        value={data.rely}
                    />
                </ProCard>

                <ProCard title={<Text>适配版本</Text>} bordered headerBordered style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', marginBottom: 20 }} loading={loading}>
                    <Select
                        mode="multiple"
                        style={{
                            width: '100%',
                        }}
                        placeholder="选择当前插件适配的版本"
                        onChange={handleCoreChange}
                        options={data.cores}
                        value={data.core}
                    />
                </ProCard>

                <ProCard title={<Text>操作</Text>} bordered headerBordered style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', marginBottom: 20 }} loading={loading}>
                    {id.id ?
                        <>
                            <Button type="primary" onClick={Save}>更新</Button>
                        </>
                        :
                        <>
                            <Button type="primary" onClick={Send}>发布</Button>
                            <Popconfirm
                                title="二次确认"
                                description="这将会清理当前所有数据并重新写内容的,是否确认重置内容?"
                                onConfirm={confirm}
                                okText="是"
                                cancelText="否"
                            >
                                <Button style={{ marginLeft: 20 }}>重置</Button>
                            </Popconfirm>
                        </>
                    }

                </ProCard>

                <ProCard title={<Text>内容</Text>} bordered headerBordered style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', marginBottom: 20 }} loading={loading}>
                    <div className='w-e-dark' style={{ border: '1px solid #ccc', zIndex: 100 }}>
                        <Toolbar
                            editor={editor}
                            defaultConfig={toolbarConfig}
                            mode="default"

                            style={{ borderBottom: '1px solid #ccc' }}
                        />
                        <Editor
                            defaultConfig={editorConfig}
                            value={html}
                            onCreated={setEditor}
                            onChange={(editor) => setHtml(editor.getHtml())}
                            mode="default"
                            style={{ height: '500px', overflowY: 'hidden' }}
                        />
                    </div>

                    {/* <div style={{ width: '49.9%', float: 'left', height: 600 }}>
                        <TextArea style={{ height: 600 }} showCount rows={20} maxLength={10000} value={data.markdown} name='markdown' onChange={onChange} />
                    </div>
                    <div style={{ width: '49.9%', float: 'right', backgroundColor: 'rgba(187, 223, 255, 1.0)', height: 600 }} className='edit_html'><div style={{ padding: 20, backgroundColor: 'rgba(187, 223, 255, 1.0)', height: '100%' }} className='markdown-body' dangerouslySetInnerHTML={{ __html: data.html }}></div></div> */}
                </ProCard>
            </div>


            <Drawer
                title="上传文件"
                width={500}
                onClose={onClose}
                open={open}
            >
                <Dragger {...uploadProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">点击或拖拽文件到此区域上传</p>
                    <p className="ant-upload-hint">
                        仅支持大小为10MB以内的单个文件上传,请遵守中国法律法规,禁止上传色情等违法图片。
                    </p>
                </Dragger>
            </Drawer>
        </div>
    )
}

export default Edit